/**
 * @copyright © 2015, Rick Wong. All rights reserved.
 */
"use strict";

module.exports = require("react");



//////////////////
// WEBPACK FOOTER
// ./~/react-transmit/src/lib/react.js
// module id = 159
// module chunks = 0